import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  data:{}
}

export const initSASlice = createSlice({
  name: 'initSA',
  initialState,
  reducers: {
    setData: (state,action) => {
      state.data = action.payload;
    }
  },
})

export const { setData } = initSASlice.actions;

export default initSASlice.reducer;